module.exports = __webpack_public_path__ + "static/media/star-line.d7e75e65.svg";